@if (items(); as taskItems) {
  @if (taskItems.length) {
    <div class="govuk-!-margin-bottom-9">
      <h2 class="govuk-heading-m govuk-!-margin-bottom-2">{{ heading() }}</h2>

      @if (!noBorders()) {
        <hr class="govuk-!-margin-bottom-3" />
      }

      @for (item of taskItems; track item.taskId) {
        <div class="govuk-grid-row">
          <div class="govuk-grid-column-three-quarters">
            <h3 class="govuk-heading-s govuk-!-margin-bottom-1">
              {{ item.taskType | itemName }}
            </h3>

            @if (item.daysRemaining !== null && item.daysRemaining !== undefined) {
              <p data-testid="days-remaining" style="float: left">
                Days Remaining: {{ item.daysRemaining | daysRemaining }}
              </p>
            }
          </div>

          <div class="govuk-grid-column-one-quarter">
            <a
              [routerLink]="item | itemLink"
              [state]="{ isWorkflow: true }"
              class="govuk-button govuk-button--secondary govuk-!-margin-bottom-2"
              style="float: right"
            >
              View task
            </a>
          </div>

          @if (!noBorders()) {
            <hr class="govuk-!-margin-bottom-3" />
          }
        </div>
      }
    </div>
  }
}
